import GenderType     from "../fundamentals/gender/GenderType";
import Name           from "../fundamentals/name/Name";
import CustomerNumber from "./CustomerNumber";

class CustomerDetail {
  constructor(
    private readonly _number: CustomerNumber = new CustomerNumber(),
    private readonly _name: Name = new Name(),
    private readonly _genderType: GenderType = GenderType.NOT_KNOWN,
  ) {
  }

  get number() {
    return this._number;
  }

  get name() {
    return this._name;
  }

  get genderType() {
    return this._genderType;
  }

  public genderLabel(): string {
    switch (this._genderType) {
      default:
      case GenderType.NOT_KNOWN:
        return "未選択";
      case GenderType.MALE:
        return "男性";
      case GenderType.FEMALE:
        return "女性";
      case GenderType.NOT_APPLICABLE:
        return "その他";
    }
  }
}

export default CustomerDetail;
